<script>
import MetisMenu from "metismenujs/dist/metismenujs";

import { menuItems } from "./menu";
import moment from 'moment';
import 'moment-timezone';

/**
 * Sidenav component
 */
export default {
    data() {
        return {
            menuItems: menuItems,
            menuData: null,
          localTime: '',
          currentTime: ''
        };
    },
  props: {
    isCondensed: {
      type: Boolean,
      default: false,
    },
  },
  mounted(){
      this.createFn()
    this.getTime()
  },
  methods: {
    hasItems(item) {
        return item.subItems !== undefined ? item.subItems.length > 0 : false;
    },
    toggleMenu(event) {
        event.currentTarget.nextElementSibling.classList.toggle("mm-show");
    },
    createFn () {
      // eslint-disable-next-line no-unused-vars
      var menuRef = new MetisMenu("#side-menu");
      var links = document.getElementsByClassName("side-nav-link-ref");
      var matchingMenuItem = null;
      const paths = [];

      for (var i = 0; i < links.length; i++) {
        paths.push(links[i]["pathname"]);
      }
      var itemIndex = paths.indexOf(window.location.pathname);
      if (itemIndex === -1) {
        const strIndex = window.location.pathname.lastIndexOf("/");
        const item = window.location.pathname.substr(0, strIndex).toString();
        matchingMenuItem = links[paths.indexOf(item)];
      } else {
        matchingMenuItem = links[itemIndex];
      }

      if (matchingMenuItem) {
        matchingMenuItem.classList.add("active");
        var parent = matchingMenuItem.parentElement;

        /**
         * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
         * We should come up with non hard coded approach
         */
        if (parent) {
          parent.classList.add("mm-active");
          const parent2 = parent.parentElement.closest("ul");
          if (parent2 && parent2.id !== "side-menu") {
            parent2.classList.add("mm-show");

            const parent3 = parent2.parentElement;
            if (parent3) {
              parent3.classList.add("mm-active");
              var childAnchor = parent3.querySelector(".has-arrow");
              var childDropdown = parent3.querySelector(".has-dropdown");
              if (childAnchor) childAnchor.classList.add("mm-active");
              if (childDropdown) childDropdown.classList.add("mm-active");

              const parent4 = parent3.parentElement;
              if (parent4 && parent4.id !== "side-menu") {
                parent4.classList.add("mm-show");
                const parent5 = parent4.parentElement;
                if (parent5 && parent5.id !== "side-menu") {
                  parent5.classList.add("mm-active");
                  const childanchor = parent5.querySelector(".is-parent");
                  if (childanchor && parent5.id !== "side-menu") {
                    childanchor.classList.add("mm-active");
                  }
                }
              }
            }
          }
        }
      }
    },
    hasAccess(permissions){
      const userPermissions = JSON.parse(localStorage.getItem('userPermissions'));
      let access = true;
        if (permissions){
          access = userPermissions.some( p => permissions.includes(p));
        }
        return access
    },
    checkIfChildHasAccess(routes){
      const userPermissions = JSON.parse(localStorage.getItem('userPermissions'));
      const combinedPermissions = []
      routes.forEach((route)=>{
        if (route.permissions) {
          combinedPermissions.push(...route.permissions)
        }
      })
      let access = true;
      access = userPermissions.some( p => combinedPermissions.includes(p));
      return access
    },
    getTime(){
      setInterval(() => {
        this.localTime = moment().format('YYYY-MM-DD HH:mm:ss')
        this.currentTime = moment().tz("Africa/Nairobi").format('YYYY-MM-DD HH:mm:ss')
      }, 1000)
    },
    formatTime(time,fm){
      return moment(time).format(fm)
    }
  },
  computed: {
    localTimezone(){
      return moment.tz.guess()
    },
  }
};
</script>

<template>
<!-- ========== Left Sidebar Start ========== -->

<!--- Sidemenu -->
<div id="sidebar-menu">
    <!-- Left Menu Start -->
    <ul id="side-menu" class="metismenu list-unstyled">
<!--      <li class="menu-title">-->
<!--        <span class="h5 text-secondary">User Role</span>-->
<!--      </li>-->

        <template v-for="item in menuItems">
            <li class="menu-title" v-if="item.isTitle" :key="item.id">
                {{ $t(item.label) }}
            </li>
            <li v-if="!item.isTitle && !item.isLayout" :key="item.id">
                <a v-if="hasItems(item) && checkIfChildHasAccess(item.subItems)" href="javascript:void(0);" class="is-parent" :class="{ 'has-arrow': !item.badge, 'has-dropdown': item.badge }">
                    <i :class="`bx ${item.icon}`" v-if="item.icon"></i>
                    <span>{{ $t(item.label) }}</span>
                    <span :class="`badge rounded-pill bg-${item.badge.variant} float-end`" v-if="item.badge">{{ $t(item.badge.text) }}</span>
                </a>

                <router-link :to="item.link" v-if="!hasItems(item)" class="side-nav-link-ref">
                    <i :class="`bx ${item.icon}`" v-if="item.icon"></i>
                    <span>{{ $t(item.label) }}</span>
                    <span :class="`badge rounded-pill bg-${item.badge.variant} float-end`" v-if="item.badge">{{ $t(item.badge.text) }}</span>
                </router-link>

                <ul v-if="hasItems(item)" class="sub-menu" aria-expanded="false">
                    <li v-for="(subitem, index) of item.subItems" :key="index">
                        <router-link :to="subitem.link" v-if="hasAccess(subitem.permissions) && !hasItems(subitem)" class="side-nav-link-ref">{{ $t(subitem.label) }}</router-link>
                        <a v-if="hasItems(subitem)" class="side-nav-link-a-ref has-arrow" href="javascript:void(0);">{{ $t(subitem.label) }}</a>
                        <ul v-if="hasItems(subitem)" class="sub-menu mm-collapse" aria-expanded="false">
                            <li v-for="(subSubitem, index) of subitem.subItems" :key="index">
                                <router-link :to="subSubitem.link" class="side-nav-link-ref">{{ $t(subSubitem.label) }}</router-link>
                            </li>
                        </ul>
                    </li>
                </ul>
            </li>
        </template>

      <div style="position: fixed;bottom: 0;margin-bottom: 30px;" v-if="!isCondensed">
        <button class="btn header-item text-white" v-if="localTimezone === 'Africa/Nairobi'">
          <span>Local Time: {{localTime}}</span>
        </button>
        <div class="d-grid text-white text-end" v-else>
          <span class="mb-2">Current Time: {{currentTime}}</span>
          <span>Local Time: {{localTime}}</span>
        </div>
      </div>
      <div v-else>
        <div style="padding: 15px;color: #a6b0cf;text-align: center" v-if="localTimezone === 'Africa/Nairobi'">
          <div>
            <span>Local</span><br/>
            <span>Time</span><br/>
            <span>{{formatTime(localTime, "HH")}}</span><br/>
            <span>{{formatTime(localTime, "mm")}}</span><br/>
            <span>{{formatTime(localTime, "ss")}}</span><br/>
          </div>
        </div>
        <div style="padding: 15px;color: #a6b0cf;text-align: center" v-else>
          <div>
            <span>Local</span><br/>
            <span>Time</span><br/>
            <span>{{formatTime(localTime, "HH")}}</span><br/>
            <span>{{formatTime(localTime, "mm")}}</span><br/>
            <span>{{formatTime(localTime, "ss")}}</span><br/>
          </div>
          <div class="mt-4">
            <span>Current</span><br/>
            <span>Time</span><br/>
            <span>{{formatTime(localTime, "HH")}}</span><br/>
            <span>{{formatTime(localTime, "mm")}}</span><br/>
            <span>{{formatTime(localTime, "ss")}}</span><br/>
          </div>
        </div>
      </div>
    </ul>

</div>
<!-- Sidebar -->
</template>
